export const Bulletin = [
  {
    id: 1,
    name: "TNSDA March 26 2022 Bulletin",
    docSrc: "https://drive.google.com/file/d/1NVZKKzCFguA3MYfRiIV-j9499PePlvVj/view?usp=sharing",
  },
];
